import React, { FC } from 'react'
import { ToolbarButton } from '@/components/toolbar/atoms'
import { PluginNames } from '@/model/Plugins'
import { ToolbarElementProps } from '@/model/Toolbar'
import { platformShortCutLabel } from '@/utils/platform.utils'

export const AlignmentGroup: FC<ToolbarElementProps> = ({ editor }) => {
  const disabled = editor.isActive(PluginNames.ImageResize)

  const isAlignmentActive = (textAlign: string) => editor.isActive({ textAlign })
  const toggleAlignment = (textAlign: string) =>
    editor.chain().focus().setTextAlign(textAlign).run()

  return (
    <>
      <ToolbarButton
        title={`Aligner à gauche (${platformShortCutLabel('$CTRL + Shift + L')})`}
        icon="AlignLeft"
        active={isAlignmentActive('left')}
        onClick={() => toggleAlignment('left')}
        disabled={disabled}
        testId="button-toolbar-editor-align_left"
      />
      <ToolbarButton
        title={`Aligner au centre (${platformShortCutLabel('$CTRL + Shift + E')})`}
        icon="AlignCenter"
        active={isAlignmentActive('center')}
        onClick={() => toggleAlignment('center')}
        disabled={disabled}
        testId="button-toolbar-editor-align_center"
      />
      <ToolbarButton
        title={`Aligner à droite (${platformShortCutLabel('$CTRL + Shift + R')})`}
        icon="AlignRight"
        active={isAlignmentActive('right')}
        onClick={() => toggleAlignment('right')}
        disabled={disabled}
        testId="button-toolbar-editor-align_right"
      />
      <ToolbarButton
        title={`Justifier (${platformShortCutLabel('$CTRL + Shift + J')})`}
        icon="AlignJustify"
        active={isAlignmentActive('justify')}
        onClick={() => toggleAlignment('justify')}
        disabled={disabled}
        testId="button-toolbar-editor-align_justify"
      />
    </>
  )
}
